import type { Image } from '~publish/legacy/composer/composer/entities/factories'
import { MediaAttachmentTypes } from '~publish/legacy/constants'

import { CircleAvatar } from '../../../Common/components/CircleAvatar'
import { EmptyMediaPlaceholder, PostWrapper } from '../../../Common/styles'
import {
  DEFAULT_AVATAR,
  getMediaProperties,
  gifAsImage,
} from '../../../Common/utils'
import type { PinterestContent, ProfilePreview } from '../../../types'
import { VideoPlayer } from '../VideoPlayer'

import previewStyles from '../../PinterestPreview.module.css'
import styles from './Post.module.css'

import type { JSX } from 'react'

const ImagePreview = ({ images }: { images: Image[] }): React.JSX.Element => {
  const firstImage = images[0]

  return (
    <div className={styles.imageWrapper} data-testid="preview-images">
      <img
        className={styles.image}
        src={firstImage.url}
        alt="Pinterest post preview"
      />
      {firstImage.mediaType === MediaAttachmentTypes.GIF && (
        <span className={previewStyles.tag}>GIF</span>
      )}
    </div>
  )
}

const PinterestPost = ({
  content,
  profile,
}: {
  content: PinterestContent
  profile: ProfilePreview
}): JSX.Element => {
  const { avatar, username } = profile
  const { images, gif, video, title } = content
  const allImages = images?.length ? images : gif ? [gifAsImage(gif)] : []
  const { hasImages, hasVideo, hasGif } = getMediaProperties(content, null)

  return (
    <PostWrapper className={styles.postWrapper}>
      {(hasImages || hasGif) && <ImagePreview images={allImages} />}
      {hasVideo && video && <VideoPlayer video={video} />}
      {!hasImages && !hasVideo && !hasGif && (
        <EmptyMediaPlaceholder service="pinterest" className={styles.empty} />
      )}
      {title && (
        <div className={styles.title} translate="no">
          {title}
        </div>
      )}
      <div className={styles.footer}>
        <CircleAvatar
          src={avatar || DEFAULT_AVATAR}
          alt={username}
          size="xsmall"
        />
        <div className={styles.usernameWrapper}>
          <span className={styles.username} translate="no">
            {username}
          </span>
        </div>
      </div>
    </PostWrapper>
  )
}

export default PinterestPost
